const networkErrorCodes = [
  'ERR_NETWORK', // Error general de red, común con Axios cuando falla la conexión.
  'ERR_CERT_COMMON_NAME_INVALID', // El nombre del certificado SSL no coincide con el dominio.
  'ERR_CERT_AUTHORITY_INVALID', // El certificado SSL no fue emitido por una autoridad confiable.
  'ERR_CERT_DATE_INVALID', // Certificado SSL expirado o aún no válido.
  'ERR_CERT_WEAK_SIGNATURE_ALGORITHM', // Certificado usa un algoritmo débil o no seguro.

  'ERR_NAME_NOT_RESOLVED', // No se pudo resolver el nombre DNS del host.
  'ERR_CONNECTION_TIMED_OUT', // Tiempo de espera agotado al intentar conectar.
  'ERR_CONNECTION_RESET', // La conexión fue cerrada abruptamente por el servidor.
  'ERR_CONNECTION_REFUSED', // El servidor rechazó la conexión (nada está escuchando en ese puerto).
  'ERR_CONNECTION_ABORTED', // La conexión fue interrumpida inesperadamente.

  'ERR_TIMED_OUT', // Tiempo de espera agotado (puede aplicarse a varias capas).
  'ERR_INTERNET_DISCONNECTED', // El navegador detectó que no hay conexión a Internet.
  'ERR_ADDRESS_UNREACHABLE', // El host está fuera de alcance o no enrutado.

  'ERR_FAILED', // Error genérico, sin detalles específicos.
  'ERR_ABORTED', // La solicitud fue cancelada por el cliente o el navegador.

  'ERR_EMPTY_RESPONSE', // El servidor no devolvió ningún dato (ni siquiera encabezados).
  'ERR_HTTP2_PROTOCOL_ERROR', // Error en el protocolo HTTP/2.
  'ERR_HTTP_HEADERS_TIMEOUT', // El servidor no envió los encabezados a tiempo.

  'ERR_BAD_REQUEST', // El servidor no pudo interpretar la solicitud (código 400).
  'ERR_BLOCKED_BY_CLIENT', // El cliente (o extensión del navegador) bloqueó la solicitud.
  'ERR_BLOCKED_BY_RESPONSE', // El servidor o política bloqueó la respuesta.

  'ERR_CONTENT_LENGTH_MISMATCH', // El tamaño del contenido no coincide con lo declarado en los headers.

  'ERR_SSL_PROTOCOL_ERROR', // Error durante el handshake SSL/TLS.
  'ERR_SSL_VERSION_OR_CIPHER_MISMATCH', // El servidor usa una versión SSL/TLS o cifrado no compatible.

  'ECONNABORTED', // Axios: la solicitud fue abortada manualmente (timeout u otro motivo).
  'ECONNREFUSED', // Node.js: el servidor rechazó la conexión (como `ERR_CONNECTION_REFUSED`).
  'ENOTFOUND', // Node.js: no se pudo encontrar la dirección del host.
  'EHOSTUNREACH', // Node.js: no hay ruta para llegar al host.
  'EAI_AGAIN', // Node.js: fallo temporal en la resolución DNS (como un timeout).
];

export function getErrMessages(errRequest) {
  if (errRequest.response?.data && errRequest.response?.data?.messages) {
    return errRequest.response.data.messages;
  }

  if (
    errRequest.response?.data &&
    !errRequest.response.data.messages &&
    errRequest.response.data.message
  ) {
    return [errRequest.response.data.message];
  }

  if (errRequest.response && errRequest.response.status) {
    return [`${errRequest.response.status?.toString()}: ${errRequest.message}`];
  }

  if (networkErrorCodes.includes(errRequest.code)) {
    return [`${errRequest?.code?.toString()}: ${errRequest.message}`];
  }

  if (errRequest instanceof SyntaxError && errRequest.message.includes('Unexpected token')) {
    return ['Failed to parse JSON. The response might not be a valid JSON file.'];
  }

  if (errRequest.message && !errRequest.response && !errRequest.code) {
    return [errRequest.message];
  }

  return [];
}

export function getAccumulatedErrors(error) {
  if (error.inner) {
    const errAccumulator = [];
    error.inner.forEach((err) => {
      errAccumulator.push(`Error en ${err.path}: ${err.message}`);
    });
    return errAccumulator;
  }
  return error;
}
